import { FC, ReactNode } from 'react';
import classlist from 'utils/classlist';
import styles from './style.scss';

export interface AlertProps {
    variant?: 'primary' | 'success' | 'danger' | 'warning' | 'info';
    className?: string;
    children?: ReactNode;
    message?: ReactNode;
    size?: 'sm' | 'lg';
}

// 设计稿：https://www.figma.com/design/7lfUKmAiXbsm5y0oC82NQN/Web-H5%E8%A7%84%E8%8C%83?node-id=266-650
const Alert: FC<AlertProps> = ({ message, children, className, variant = 'primary', size }) => {
    return (
        <div
            className={classlist(styles.root, className, {
                [styles[`alert-${variant}`]]: variant,
                [styles[`alert-${size}`]]: !!size
            })}>
            {message || children}
        </div>
    );
};

export default Alert;
